module.exports = __webpack_public_path__ + "static/media/1007141.5325347c.jpg";